import { render, staticRenderFns } from "./PlatingTasks2.vue?vue&type=template&id=2816c058&scoped=true&"
import script from "./PlatingTasks2.vue?vue&type=script&lang=js&"
export * from "./PlatingTasks2.vue?vue&type=script&lang=js&"
import style0 from "./PlatingTasks2.vue?vue&type=style&index=0&id=2816c058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816c058",
  null
  
)

export default component.exports